import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import type { QuoteItem } from '../../@types/quote-item';

export const sessionJurisdictionIdOfQuote = () => sessionStorage.getItem('quoteJurisdictionId');

const fetchQuote = (quoteId: string) => apiFetch<QuoteItem>(`/v1/pricing_quotes/${quoteId}`);

export default fetchQuote;
